import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpResponse,
    HttpErrorResponse
   } from '@angular/common/http';
   import { Observable, throwError } from 'rxjs';
   import { retry, catchError } from 'rxjs/operators';
   import swal from 'sweetalert/dist/sweetalert.min.js';
   
   export class HttpErrorInterceptor implements HttpInterceptor {
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next.handle(request)
        .pipe(
          retry(1),
          catchError((error: HttpErrorResponse) => {
            let errorMessage = '';
            if (error.error instanceof ErrorEvent) {
              // client-side error
              errorMessage = `Error: ${error.error.message}`;
              // errorMessage = `Error: Please try again`;
            } else {
              // server-side error
              errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
              // errorMessage = `Error: Please try Again`;
            }
            // console.log(error);
            // window.alert(errorMessage);
            swal({
              title: "Ups!",
              // text: errorMessage,
              text: "Terjadi kesalahan, silahkan ulangi dalam beberapa saat",
              icon: "error",
            });
            
            return throwError(errorMessage);
          })
        )
    }
   }